import React from 'react';
import T from 'prop-types';
// components
import ReactTooltip from 'rc-tooltip';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './SVRBadge.module.scss';

const cn = classnames.bind(styles);

// Pill badge for SVR question marks (corrected / failed on previous report / not corrected)
const SVRBadge = ({ color, children, onRemove, className, tooltip }) => {
  const badge = (
    <span
      className={classnames(cn('svr-badge', color, { clickable: !!onRemove }), className)}
      onClick={onRemove}
    >
      {children}
      {onRemove && <i className={cn('fa fa-times', 'remove-icon')} />}
    </span>
  );

  if (!tooltip) {
    return badge;
  }

  return (
    <ReactTooltip mouseEnterDelay={0.2} placement="top" overlayClassName="tooltip-message" overlay={tooltip}>
      {badge}
    </ReactTooltip>
  );
};

SVRBadge.propTypes = {
  color: T.oneOf(['green', 'red']).isRequired,
  children: T.node.isRequired,
  onRemove: T.func,
  className: T.string,
  tooltip: T.node,
};

export default SVRBadge;
